import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import LayoutContainer from 'components/Common/LayoutContainer'
import Image from 'components/Common/ResponsiveImage'
import Pane from 'components/Common/Pane'
import Player from 'components/Common/Player'
import MarkdownRender from 'LuxKit/MarkdownRender'
import PaneBody from 'components/Common/Pane/PaneBody'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const StyledPlayer = styled(Player)`
  display: inline-block;
  width: 100%;
  height: ${rem(205)};

  ${mediaQueryUp.tablet} {
    height: ${rem(385)};
  }
`

interface Props {
  title?: string
  header?: string
  videoUrl?: string
  image?: string
  description?: string
  description2?: string
  callToActionText?: string
  callToActionLink?: string
}

function Content(props: Props) {
  const {
    title,
    header,
    videoUrl,
    image,
    description,
    description2,
    callToActionLink,
    callToActionText,
  } = props

  return (
    <Pane>
      <PaneBody size="xl-y">
        <VerticalSpacer gap={20}>
          <LayoutContainer size="md">
            <VerticalSpacer gap={20}>
              {title && <Heading variant="heading3" align="center">{ title }</Heading>}
              {header && <Heading variant="heading3" align="center">{ header }</Heading>}
              {description && <MarkdownRender content={description} />}
            </VerticalSpacer>
          </LayoutContainer>
          <LayoutContainer size="sm">
            {videoUrl && (
              <StyledPlayer
                url={videoUrl}
              />
            )}
            {image && (
              <Image
                id={image}
                key="image"
                mobileAspectRatio="16:9"
              />
            )}
          </LayoutContainer>
          {(description2 || callToActionLink) && <LayoutContainer size="md">
            <VerticalSpacer gap={4}>
              {description2 && <MarkdownRender content={description2} />}
              {callToActionLink && <TextButton kind="tertiary" target="_blank" rel="noopener noreferrer" href={callToActionLink}>
                {callToActionText ?? 'Visit website'}
              </TextButton>}
            </VerticalSpacer>
          </LayoutContainer>}
        </VerticalSpacer>
      </PaneBody>
    </Pane>
  )
}

export default Content
